angular.module('SpidApp')

.factory('CurrencyHistoryService',
	    ['Restangular', '_', 'CurrencyHistory',
function (Restangular,   _,   CurrencyHistory) {
	var CurrencyHistoryService = {
		find: function (agencyId, currencyId) {
			if (!agencyId || !currencyId) {
				throw 'CurrencyHistoryService::find() - Missing parameters'
			}

			return Restangular.one('agencies', agencyId).one('currencies', currencyId).all('currency-history').getList().then(function (currenciesHistoryData) {
				return _.map(currenciesHistoryData, function(currencyHistoryData){
					return new CurrencyHistory(currencyHistoryData)
				})
			})
		}
	}

	return CurrencyHistoryService
}])
